import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalAppService} from '../../../core/commons/global-app.service';
import {FormViewService} from '../../services/form-view.service';
import {FormView} from '../../domain/form-view';
import {FormViewField} from '../../domain/form-view-field';
import {FormViewFieldData} from '../../domain/form-view-field-data';
import {FormViewData} from 'app/form-views/domain/form-view-data';
import {MessageSeverity} from 'app/core/commons/message-severity';
import {Location} from '@angular/common';
import {MatDialog} from '@angular/material';
import {SaveViewDialogComponent} from '../data/save-view-dialog/save-view-dialog.component';

@Component({
    selector: 'app-form-view-detail',
    templateUrl: './form-view-detail.component.html',
    styleUrls: ['./form-view-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [FormViewService]
})

/**
 *  http://localhost:4200/#/home/view/detail/31
 */

export class FormViewDetailComponent implements OnInit {

    viewModel: FormView = null;

    formGroup: FormGroup = null;

    paragraphs: FormViewField[][] = [];

    fieldValues: FormViewFieldData[] = [];

    saveDisabled = true;

    constructor(private fb: FormBuilder,
                private route: ActivatedRoute,
                private router: Router,
                private appService: GlobalAppService,
                private cd: ChangeDetectorRef,
                private viewService: FormViewService,
                private location: Location,
                public dialog: MatDialog
    ) {
    }

    ngOnInit() {
        this.route.params
            .map(params => params['id'])
            .switchMap(id => this.viewService.get(id))
            .subscribe(view => {
                this.viewModel = view;
                this.buildFormGroup();
            });
        this.cd.markForCheck();
    }

    buildFormGroup() {
        this.formGroup = new FormGroup({});
        this.formGroup.addControl("name", new FormControl(''));
        this.viewModel.fields.forEach(f => {
            if (f.placeholder.includes('{@}')) {
                const validators = f.getValidators();
                validators.push(defaultValueValidator('campo a completar'));
                const formControl = new FormControl('campo a completar', validators)
                formControl.valueChanges.subscribe(value => {
                    f.placeholder = value;
                    this.checkValidResponses();
                });
                this.formGroup.addControl(f.id.toString(), formControl);
            }
            if (f.newParagraph) {
                this.paragraphs.push([f])
            } else {
                this.paragraphs[this.paragraphs.length - 1].push(f);
            }
        });

        this.cd.markForCheck();
    }

    checkValidResponses() {
        this.saveDisabled = false;
        Object.keys(this.formGroup.controls).forEach(key => {
            const control: AbstractControl = this.formGroup.get(key);
            if (control.enabled && control.invalid) {
                this.saveDisabled = true;
            }
        });
        this.cd.markForCheck();
    }

    save(): void {
        this.appService.setLoading(true);
        const viewData = new FormViewData();
        viewData.view = this.viewModel;
        viewData.name = this.formGroup.get("name").value;
        Object.keys(this.formGroup.controls).forEach(key => {
            const control: AbstractControl = this.formGroup.get(key)
            if (control.enabled && ( key != "name") ) {
                const fieldData = new FormViewFieldData();
                fieldData.value = control.value;
                fieldData.field = new FormViewField({id: key});
                viewData.values.push(fieldData);
            }
        });
        this.viewService.fill(viewData).subscribe(() => {
            this.appService.setLoading(false);
            this.appService.sendMsg(MessageSeverity.SUCCESS, 'Éxito', 'Vista modelo completada exitosamente');
            this.location.back();
        }, error => {
            this.appService.setLoading(false);
            this.appService.sendMsg(MessageSeverity.ERROR, 'Error', 'Se produjo un error al guardar');
        })
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(SaveViewDialogComponent, {
            width: '500px',
            data: {name: ''}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.formGroup.get("name").setValue(result);
                this.save();
            }
        });
    }
}

/** Validación del valor por defecto */
export function defaultValueValidator(value: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const invalid = control.value === value;
        return invalid ? {'defaultValue': {value: control.value}} : null;
    };
}



// WEBPACK FOOTER //
// ./src/app/form-views/components/form-view-detail/form-view-detail.component.ts